import OnspaceCable from '@onpace/onspace-core/components/cable'

const urlMeta = document.querySelector('meta[name=onspace-cms-actioncable-url]')
const url = urlMeta ? urlMeta.content : '/'

const cable = new OnspaceCable(url)
cable.connect()

export default cable
